import type { AxiosError } from 'axios'

export enum PromoPlanErrorCode {
  PlanAlreadyEnded = 'PlanAlreadyEnded',
}

interface BusinessExceptionBody {
  message: string
  errorCode?: string
  type: string
}

export const getPromoPlanErrorCode = (descriptor: { raw: unknown }): string | undefined =>
  (descriptor.raw as AxiosError<BusinessExceptionBody>)?.response?.data?.errorCode
